module.exports = __webpack_public_path__ + "img/block-loupe.55431e02.png";